/* ==========================================================================
   EARTH JUNIOR - Stage B page JS.
   Loaded (defer) by each bk-ej-* section; the __bkEjInit guard makes repeat
   tags a no-op. Runs inside the STANDARD Beauty Kitchen layout.

   Cart contract (from the theme's own assets/product-cart.js):
   - JSON POST { items:[{id, quantity}] } to the cart add route
   - 422 message in response.description
   - success dispatches document CustomEvent('eurus:cart:items-changed')
   Rebuy (verified at runtime, Stage B recon):
   - Smart Cart auto-opens on add (skip_open opt-out); Rebuy.SmartCart.show()
   - document events: 'rebuy:cart.change', 'rebuy.add', 'rebuy.ready'
     (rebuy:cart.change fixes the Stage A free-gift undercount)

   Motion: GSAP only, inside gsap.matchMedia('(prefers-reduced-motion:
   no-preference)'). All initial hidden states are applied by JS, so the page
   renders complete without JS and under reduced motion. Verified at runtime on
   the preview URL (Stage B): neither gsap nor ScrollTrigger is present on page
   templates - bk-hp-header's copy is homepage-only - so both are injected here
   from the theme's own assets, each guarded so a pre-existing copy wins.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__bkEjInit) return;
  window.__bkEjInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // GSAP is served from the theme's own assets (same directory as this file), so
  // it comes off the Shopify CDN on the storefront origin - no third-party DNS
  // or TLS hop. This file is a plain .js asset and cannot call asset_url, so the
  // sibling URL is derived from this script's own src.
  var SELF = (document.currentScript && document.currentScript.src) ||
    (function () { var s = document.querySelector('script[src*="bk-ej.js"]'); return s ? s.src : ''; })();
  function sibling(name, fallback) {
    if (!SELF) return fallback;
    var url = SELF.replace(/\/bk-ej\.js(\?[^/]*)?$/, '/' + name);
    return url === SELF ? fallback : url;
  }
  var GSAP_SRC = sibling('bk-ej-gsap.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js');
  var ST_SRC = sibling('bk-ej-scrolltrigger.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js');

  function cartAddUrl() {
    var url = (window.Eurus && window.Eurus.cart_add_url) || ROOT + 'cart/add';
    return url.indexOf('.js') === -1 ? url + '.js' : url;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- GSAP loader (guarded, once) ---------------- */
  function injectScript(src) {
    if (document.querySelector('script[src="' + src + '"]')) return;
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    document.head.appendChild(s);
  }
  function ensureGsap(cb) {
    if (!window.gsap) injectScript(GSAP_SRC);
    var tries = 0;
    (function poll() {
      if (window.gsap) {
        if (!window.ScrollTrigger) injectScript(ST_SRC);
        (function poll2() {
          if (window.ScrollTrigger) { cb(); return; }
          if (++tries > 200) return;
          window.setTimeout(poll2, 50);
        })();
        return;
      }
      if (++tries > 200) return;
      window.setTimeout(poll, 50);
    })();
  }

  /* ---------------- announcements + bag count ---------------- */
  function announce(message) {
    var region = document.querySelector('[data-bk-ej-live]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 50);
  }

  function paintBagCount(count) {
    document.querySelectorAll('#cart-icon-bubble span, .bk-hp-header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }
  function refreshBagCount() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintBagCount(cart.item_count); return cart; })
      .catch(function () { /* non-fatal */ });
  }
  // Rebuy owns the cart after automations (free gifts) - its change event is
  // the authoritative moment to re-read the count (Stage A undercount fix).
  document.addEventListener('rebuy:cart.change', function (e) {
    try {
      var c = e && e.detail && e.detail.cart;
      if (c && typeof c.item_count === 'number') paintBagCount(c.item_count);
      else refreshBagCount();
    } catch (err) { refreshBagCount(); }
  });

  /* ---------------- Smart Cart open ---------------- */
  function ensureCartVisible() {
    window.setTimeout(function () {
      try {
        var sc = window.Rebuy && window.Rebuy.SmartCart;
        if (sc && !sc.visible && typeof sc.show === 'function') { sc.show(); return; }
        if (!sc) showToast();
      } catch (e) { showToast(); }
    }, 600);
  }
  function showToast() {
    var existing = document.querySelector('.bk-ej-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'bk-ej-toast';
    toast.setAttribute('role', 'status');
    toast.style.cssText =
      'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:60;' +
      'background:#1F2A2A;color:#fff;padding:14px 22px;border-radius:999px;' +
      'font-weight:700;display:flex;gap:12px;align-items:center;box-shadow:0 6px 24px rgba(0,0,0,.25);';
    toast.innerHTML = 'Added to bag <a href="' + ROOT + 'cart" style="color:#FFD84A;text-decoration:underline;">View bag</a>';
    document.body.appendChild(toast);
    window.setTimeout(function () { toast.remove(); }, 5000);
  }

  /* ---------------- quantity steppers (1-10) ---------------- */
  function initSteppers() {
    document.querySelectorAll('[data-bk-ej-qty]').forEach(function (q) {
      var out = q.querySelector('output');
      var dec = q.querySelector('[data-dec]');
      var inc = q.querySelector('[data-inc]');
      if (!out || !dec || !inc) return;
      function set(n) {
        n = Math.min(10, Math.max(1, n));
        out.textContent = n;
        dec.disabled = n <= 1;
        inc.disabled = n >= 10;
      }
      dec.addEventListener('click', function () { set(parseInt(out.textContent, 10) - 1); });
      inc.addEventListener('click', function () { set(parseInt(out.textContent, 10) + 1); });
      set(parseInt(out.textContent, 10) || 1);
    });
  }
  function qtyFor(button) {
    var card = button.closest('[data-bk-ej-card]');
    var out = card && card.querySelector('[data-bk-ej-qty] output');
    return out ? (parseInt(out.textContent, 10) || 1) : 1;
  }

  /* ---------------- star burst (GSAP; skipped when motion is off) ---------------- */
  var STAR_PATH = 'M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.3 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z';
  var motionOn = false; // set true inside the matchMedia context
  function starBurst(button) {
    if (!motionOn || !window.gsap) return;
    for (var i = 0; i < 8; i++) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'bk-ej-burst');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.innerHTML = '<path d="' + STAR_PATH + '"/>';
      button.appendChild(svg);
      var angle = (Math.PI * 2 * i) / 8;
      (function (el) {
        window.gsap.fromTo(el,
          { x: 0, y: 0, scale: 0.3, opacity: 1, rotation: 0 },
          {
            x: Math.cos(angle) * 58, y: Math.sin(angle) * 58,
            scale: 1.1, opacity: 0, rotation: 140,
            duration: 0.75, ease: 'power2.out',
            onComplete: function () { el.remove(); }
          });
      })(svg);
    }
  }

  /* ---------------- one-click add to bag ---------------- */
  function setButtonState(button, state) {
    var label = button.querySelector('[data-bk-ej-label]');
    if (!label) return;
    if (!button.dataset.idleLabel) button.dataset.idleLabel = label.textContent;
    button.classList.remove('is-adding', 'is-added');
    if (state === 'adding') {
      button.classList.add('is-adding');
      button.setAttribute('aria-busy', 'true');
      label.textContent = button.dataset.addingLabel || 'Adding...';
    } else if (state === 'added') {
      button.classList.add('is-added');
      button.removeAttribute('aria-busy');
      label.textContent = button.dataset.addedLabel || 'Added!';
    } else {
      button.removeAttribute('aria-busy');
      label.textContent = button.dataset.idleLabel;
    }
  }
  function showCardError(button, message) {
    var card = button.closest('[data-bk-ej-card]') || button.parentElement;
    var slot = card && card.querySelector('[data-bk-ej-error]');
    if (slot) {
      slot.textContent = message;
      slot.hidden = false;
      window.setTimeout(function () { slot.hidden = true; }, 6000);
    }
  }
  function addToBag(button) {
    if (button.getAttribute('aria-busy') === 'true' || button.disabled || button.classList.contains('is-added')) return;
    var items;
    try { items = JSON.parse(button.dataset.items || '[]'); } catch (e) { items = []; }
    if (!items.length) return;
    var qty = qtyFor(button);
    items = items.map(function (item) { return { id: item.id, quantity: (item.quantity || 1) * qty }; });

    setButtonState(button, 'adding');
    // Two independent guards so the button can never stay stuck in Adding:
    // abort the request where AbortController exists, and - regardless - a
    // watchdog that releases the button if nothing has settled it by then.
    // Without the watchdog a fetch that never settles (no AbortController, or a
    // promise that neither resolves nor rejects) would leave aria-busy set and
    // every later click refused by the re-entry guard above.
    var settled = false;
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var abortTimer = controller ? window.setTimeout(function () { controller.abort(); }, 12000) : null;
    var watchdog = window.setTimeout(function () {
      if (settled) return;
      settled = true;
      setButtonState(button, 'idle');
      var stalled = 'Sorry, that took too long - nothing was added.';
      showCardError(button, stalled);
      announce(stalled);
    }, 14000);
    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, status: response.status, data: data }; });
      })
      .then(function (result) {
        if (settled) return; // the watchdog already released the button
        settled = true;
        if (!result.ok || result.status === 422 || result.data.status === 422) {
          var message = result.data.description || result.data.message || 'Sorry, something went wrong - nothing was added.';
          setButtonState(button, 'idle');
          showCardError(button, message);
          announce(message);
          return;
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        refreshBagCount();
        setButtonState(button, 'added');
        starBurst(button);
        announce((button.dataset.productTitle || 'Product') + ' added to bag');
        pushAnalytics(button, items);
        ensureCartVisible();
        window.setTimeout(function () { setButtonState(button, 'idle'); }, 2000);
      })
      .catch(function () {
        if (settled) return;
        settled = true;
        setButtonState(button, 'idle');
        var message = 'Sorry, something went wrong - nothing was added.';
        showCardError(button, message);
        announce(message);
      })
      .finally(function () {
        if (abortTimer) window.clearTimeout(abortTimer);
        window.clearTimeout(watchdog);
      });
  }
  function pushAnalytics(button, items) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'GBP',
          items: items.map(function (item) {
            return { item_id: item.id, quantity: item.quantity, item_name: button.dataset.productTitle || '' };
          })
        }
      });
    } catch (e) { /* analytics must never break ATB */ }
  }
  function initAtb() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bk-ej-atb]');
      if (button) { event.preventDefault(); addToBag(button); return; }
      // Card delegation is limited to the artwork itself - a tap on blank
      // card space (e.g. beside the stepper at 375px) must never add.
      var art = event.target.closest('.bk-ej-prod-img');
      if (!art) return;
      var card = art.closest('[data-bk-ej-card]');
      var cardButton = card && card.querySelector('[data-bk-ej-atb]');
      if (cardButton && !cardButton.disabled) addToBag(cardButton);
    });
  }

  /* ---------------- page-wide ambient drift layer ----------------
     One absolutely positioned inset-0 layer as the FIRST child of the
     template wrapper (.bk-ej-page): z-index 1 paints it above section
     backgrounds and waves, below all .bk-ej-content (same z, later in DOM).
     Killed entirely by the hero's "ambient" setting (data-bk-ej-ambient-off).
     GSAP drift is added inside the matchMedia context; without it (no JS or
     reduced motion) the layer renders static, and CSS hides the --extra
     drifters so reduced motion is also sparse. */
  var AMB_SYMBOLS = ['star', 'spark', 'heart', 'smile', 'swirl'];
  var AMB_COLORS = ['var(--ej-yellow)', 'var(--ej-orange)', 'var(--ej-purple)', 'var(--ej-pink)', 'var(--ej-ink)'];
  function initAmbient() {
    // the TEMPLATE WRAPPER only (sections also carry .bk-ej-page but add
    // .bk-ej-sec); in editor section-render contexts with no wrapper, skip -
    // a section-scoped layer would not be page-wide.
    var host = document.querySelector('.bk-ej-page:not(.bk-ej-sec)');
    if (!host || document.querySelector('[data-bk-ej-ambient-off]')) return;
    if (document.querySelector('.bk-ej-ambient')) return;
    host.classList.add('bk-ej-ambient-host');
    var layer = document.createElement('div');
    layer.className = 'bk-ej-ambient';
    layer.setAttribute('aria-hidden', 'true');
    var isMobile = window.innerWidth <= 760; // matches the CSS max-width: 760px tier
    var count = isMobile ? 7 : 14;
    var svgns = 'http://www.w3.org/2000/svg';
    var xlink = 'http://www.w3.org/1999/xlink';
    for (var i = 0; i < count; i++) {
      var svg = document.createElementNS(svgns, 'svg');
      var symbol = AMB_SYMBOLS[i % AMB_SYMBOLS.length];
      var line = i % 3 === 1 && symbol !== 'spark';
      svg.setAttribute('class', 'bk-ej-amb bk-ej-dd--' + (line ? 'line' : 'fill') + (i % 3 === 2 ? ' bk-ej-amb--extra' : ''));
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      var size = 18 + Math.round(Math.random() * 28);
      svg.style.width = size + 'px';
      svg.style.height = size + 'px';
      svg.style.top = (3 + Math.random() * 92) + '%';
      svg.style.left = (Math.random() * 94) + '%'; // static spread; GSAP takes over x
      svg.style.color = AMB_COLORS[i % AMB_COLORS.length];
      svg.style.opacity = (0.35 + Math.random() * 0.25).toFixed(2);
      var use = document.createElementNS(svgns, 'use');
      use.setAttribute('href', '#bk-ej-sym-' + symbol);
      use.setAttributeNS(xlink, 'xlink:href', '#bk-ej-sym-' + symbol);
      svg.appendChild(use);
      layer.appendChild(svg);
    }
    host.insertBefore(layer, host.firstChild);
  }
  function removeAmbient() {
    var layer = document.querySelector('.bk-ej-ambient');
    if (layer) layer.remove();
  }
  // Theme editor lifecycle: section reloads re-render the hero (and its
  // ambient toggle attribute) without a page load - reconcile the layer.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      if (document.querySelector('[data-bk-ej-ambient-off]')) removeAmbient();
      else if (!document.querySelector('.bk-ej-ambient')) initAmbient();
    });
  }

  /* ---------------- motion system (GSAP only) ---------------- */
  function pauseWhenOffscreen(tween, triggerEl) {
    window.ScrollTrigger.create({
      trigger: triggerEl,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: function () { tween.play(); },
      onEnterBack: function () { tween.play(); },
      onLeave: function () { tween.pause(); },
      onLeaveBack: function () { tween.pause(); }
    });
  }

  function initMotion() {
    // Reduced motion: no tween would ever be created, so skip the download and
    // the parse cost entirely rather than loading GSAP to register nothing.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    ensureGsap(function () {
      var gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);
      var rand = gsap.utils.random;
      var mm = gsap.matchMedia();

      // Sections whose schema "motion" toggle is off carry
      // data-bk-ej-motion-off on their root; nothing inside them animates.
      function motionAllowed(el) {
        return !el.closest('[data-bk-ej-motion-off]');
      }

      mm.add('(prefers-reduced-motion: no-preference)', function () {
        motionOn = true;

        // stagger indices for grouped reveals
        document.querySelectorAll('[data-bk-ej-stagger]').forEach(function (group) {
          Array.prototype.forEach.call(group.children, function (child, index) {
            child.setAttribute('data-bk-ej-reveal', '');
            child.style.setProperty('--i', index);
          });
        });

        // scroll reveals - hidden state applied HERE (JS only), never in CSS
        var reveals = gsap.utils.toArray('[data-bk-ej-reveal]').filter(motionAllowed);
        if (reveals.length) {
          gsap.set(reveals, { autoAlpha: 0, y: 28, scale: 0.96 });
          window.ScrollTrigger.batch(reveals, {
            start: 'top 85%',
            once: true,
            onEnter: function (batch) {
              gsap.to(batch, {
                autoAlpha: 1, y: 0, scale: 1,
                duration: 0.7, ease: 'back.out(1.6)', stagger: 0.09,
                clearProps: 'transform,opacity,visibility'
              });
            }
          });
        }

        // hero timeline: elastic splash-in, splats pop, doodles follow
        var splash = document.querySelector('.bk-ej-splash');
        if (splash && !motionAllowed(splash)) splash = null;
        if (splash) {
          var tl = gsap.timeline({ defaults: { ease: 'none' } });
          tl.fromTo(splash,
            { scale: 0.5, rotation: -7, autoAlpha: 0 },
            { scale: 1, rotation: 0, autoAlpha: 1, duration: 1.15, ease: 'elastic.out(1, 0.62)' });
          var splats = splash.parentElement.querySelectorAll('.bk-ej-splat');
          if (splats.length) {
            tl.fromTo(splats,
              { scale: 0, autoAlpha: 0 },
              { scale: 1, autoAlpha: 1, duration: 0.7, ease: 'back.out(2.4)', stagger: 0.06 },
              0.55);
          }
        }

        // ambient doodle loops - randomised, transform-only, paused offscreen
        document.querySelectorAll('[data-ej-doodle]').forEach(function (doodle) {
          if (!motionAllowed(doodle)) return;
          var kind = doodle.getAttribute('data-ej-doodle');
          var section = doodle.closest('.bk-ej-sec') || doodle.parentElement;
          var tween;
          if (kind === 'tw') {
            tween = gsap.to(doodle, { scale: 0.55, opacity: 0.35, transformOrigin: '50% 50%', duration: rand(1.6, 3.2), ease: 'sine.inOut', yoyo: true, repeat: -1, delay: rand(0, 1.2), paused: true });
          } else if (kind === 'wb') {
            tween = gsap.to(doodle, { rotation: '+=18', transformOrigin: '50% 50%', duration: rand(2.6, 4.4), ease: 'sine.inOut', yoyo: true, repeat: -1, delay: rand(0, 1), paused: true });
          } else if (kind === 'pu') {
            tween = gsap.to(doodle, { scale: 1.22, transformOrigin: '50% 50%', duration: rand(1.4, 2.4), ease: 'sine.inOut', yoyo: true, repeat: -1, delay: rand(0, 0.8), paused: true });
          } else {
            tween = gsap.to(doodle, { y: -14, rotation: '+=6', transformOrigin: '50% 50%', duration: rand(4, 7), ease: 'sine.inOut', yoyo: true, repeat: -1, delay: rand(0, 1.5), paused: true });
          }
          pauseWhenOffscreen(tween, section);
        });

        // page-wide ambient drift: slow horizontal cross with bob + rotation.
        // Rebuilt on width resize (drift distance changes); every tween pauses
        // while its drifter's row is out of the viewport.
        var ambientTweens = [];
        var ambientTriggers = [];
        function buildAmbient() {
          var layer = document.querySelector('.bk-ej-ambient');
          if (!layer) return;
          var width = layer.clientWidth;
          layer.querySelectorAll('.bk-ej-amb').forEach(function (amb) {
            amb.style.left = '0';
            var drift = gsap.fromTo(amb,
              { x: -80 },
              { x: width + 80, duration: rand(40, 90), ease: 'none', repeat: -1, paused: true });
            drift.progress(Math.random()); // spread across the page on load
            var bob = gsap.to(amb, { y: rand(-26, 26), duration: rand(3, 6), ease: 'sine.inOut', yoyo: true, repeat: -1, paused: true });
            var spin = gsap.to(amb, { rotation: 360, duration: rand(30, 70), ease: 'none', repeat: -1, paused: true });
            var group = [drift, bob, spin];
            ambientTweens.push.apply(ambientTweens, group);
            ambientTriggers.push(window.ScrollTrigger.create({
              trigger: amb,
              start: 'top bottom',
              end: 'bottom top',
              onEnter: function () { group.forEach(function (t) { t.play(); }); },
              onEnterBack: function () { group.forEach(function (t) { t.play(); }); },
              onLeave: function () { group.forEach(function (t) { t.pause(); }); },
              onLeaveBack: function () { group.forEach(function (t) { t.pause(); }); }
            }));
          });
        }
        function killAmbient() {
          ambientTweens.forEach(function (t) { t.kill(); });
          ambientTriggers.forEach(function (t) { t.kill(); });
          ambientTweens = [];
          ambientTriggers = [];
        }
        buildAmbient();
        var lastWidth = window.innerWidth;
        var resizeTimer = null;
        function onAmbientResize() {
          if (Math.abs(window.innerWidth - lastWidth) < 60) return;
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            var crossedBreakpoint = (lastWidth <= 760) !== (window.innerWidth <= 760);
            lastWidth = window.innerWidth;
            killAmbient();
            if (crossedBreakpoint) {
              // drifter COUNT differs per tier - rebuild the nodes too
              removeAmbient();
              initAmbient();
            }
            buildAmbient();
            window.ScrollTrigger.refresh();
          }, 400);
        }
        window.addEventListener('resize', onAmbientResize);
        // layer height tracks the page: refresh triggers once images are in
        window.addEventListener('load', function () { window.ScrollTrigger.refresh(); }, { once: true });

        // band drift: doodles cross the band, linear, paused offscreen
        document.querySelectorAll('.bk-ej-drift').forEach(function (drift) {
          if (!motionAllowed(drift)) return;
          var band = drift.closest('.bk-ej-band') || drift.parentElement;
          var duration = rand(36, 56);
          var tween = gsap.fromTo(drift,
            { x: 0, rotation: 0 },
            { x: window.innerWidth + 200, rotation: 360, duration: duration, ease: 'none', repeat: -1, paused: true, delay: -rand(0, duration) });
          pauseWhenOffscreen(tween, band);
        });

        // post-it sway + ribbon wiggle
        document.querySelectorAll('.bk-ej-postit').forEach(function (postit) {
          if (!motionAllowed(postit)) return;
          var tween = gsap.fromTo(postit, { rotation: -4.8 }, { rotation: -2.6, duration: 3, ease: 'sine.inOut', yoyo: true, repeat: -1, paused: true });
          pauseWhenOffscreen(tween, postit);
        });
        document.querySelectorAll('.bk-ej-banner').forEach(function (banner) {
          if (!motionAllowed(banner)) return;
          var tween = gsap.fromTo(banner, { rotation: -1.4 }, { rotation: 1.1, duration: 2.75, ease: 'sine.inOut', yoyo: true, repeat: -1, paused: true });
          pauseWhenOffscreen(tween, banner);
        });

        return function () {
          motionOn = false;
          window.clearTimeout(resizeTimer);
          killAmbient();
          window.removeEventListener('resize', onAmbientResize);
        };
      });
      // Reduced motion: no context registered; nothing is hidden, nothing moves.
    });
  }

  // Ribbon fit guard: default copy stays nowrap (single line >=480px), but
  // longer merchant-edited text must wrap rather than spill past the painted
  // shape (Codex finding, fix pass). CSS cannot measure, so check here.
  function initRibbonFit() {
    document.querySelectorAll('.bk-ej-banner').forEach(function (banner) {
      var text = banner.querySelector('.bk-ej-banner-text');
      if (!text) return;
      function fit() {
        text.style.whiteSpace = '';
        var room = banner.clientWidth - 8;
        if (text.scrollWidth > room) text.style.whiteSpace = 'normal';
      }
      fit();
      window.addEventListener('resize', fit);
    });
  }

  ready(function () {
    initSteppers();
    initAtb();
    initRibbonFit();
    initAmbient(); // before initMotion so the context finds the drifters
    initMotion();
    refreshBagCount();
  });
})();
